module.exports = __webpack_public_path__ + "img/logo-secure.64f5e5be.png";